import { render, staticRenderFns } from "./PartnerOfTheWeekDetail.vue?vue&type=template&id=0ce14e03&scoped=true"
import script from "./PartnerOfTheWeekDetail.vue?vue&type=script&lang=js"
export * from "./PartnerOfTheWeekDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce14e03",
  null
  
)

export default component.exports